export class ApiKeyEditMerchantAccessRequestDto {
  generatedPOSDeviceId?: number;
  merchantIdsToAdd?: number[];
  merchantIdsToRemove?: number[];
  merchantGroupId? : number;
}
